import renderRoutes from 'utils/renderRoutes';
import App from 'components/App';
import { isAuthenticated } from 'utils/auth';

import dashboard from './dashboard/route';
import settings from './settings/route';
import foodcourt from './foodcourt/route';
import vendor from './vendor/route';
import orders from './orders/route';
import ordersummary from './ordersummary/route';
import orderQRCode from './orderqrcode/route';
import vendorConsole from './vendorconsole/route';
import notFound from './default/route';
import login from './login/route';
import config from 'configs';

const routeConfigs = {
  redirects: [
    {
      path: '/',
      to: `/vendors/${config.defaultVendorId}`,
      exact: true,
    },
    {
      path: '/login',
      to: '/',
      exact: true,
      condition: isAuthenticated,
    },
  ],
  component: App,
  routes: [
    dashboard,
    settings,
    foodcourt,
    vendor,
    ordersummary,
    orderQRCode,
    orders,
    vendorConsole,
    login,
    notFound,
  ],
};

export default () => {
  return renderRoutes(routeConfigs);
};
